import EnterpriseNews from '../enterpriseNews/src/index.vue'

export default EnterpriseNews